import React from 'react';
import PropTypes from 'prop-types';

export default function SameAddressSwitch({checked = false, tabIndex = 0, setSameAddress}) {
  const handleChange = e => {
    // radio values are 1/0, convert these to bool
    // const value = +(e.target.value);
    setSameAddress(!checked);
  }

  return (
    <div className="my-4">
      <label className="font-normal">
        <input type="checkbox" name="same" value="1"
          tabIndex={tabIndex}
          checked={checked || false}
          onChange={handleChange}/>
        <span>
          <strong> Billing Address </strong>

          is the same as

          <strong className="whitespace-nowrap"> Shipping Address </strong>
          </span>
      </label>
    </div>
  );
}

SameAddressSwitch.propTypes = {
  same: PropTypes.bool.isRequired,
  setSameAddress: PropTypes.func.isRequired,
  tabIndex: PropTypes.number
};
